import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { initTelegram } from './lib/telegram';
import { registerServiceWorker, initNativePushTapListener } from './lib/push';
import './index.css';

initTelegram();
// Реєструємо service worker для Web Push (підписка робиться пізніше, після входу)
registerServiceWorker();
// У нативній апці: тап по сповіщенню → перехід на url з payload
initNativePushTapListener();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
